import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from 'inversify';
let SelectedCustomFieldsModelImpl = class SelectedCustomFieldsModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = [];
    }
    dispose() {
        this.update(() => []);
    }
};
SelectedCustomFieldsModelImpl = __decorate([
    injectable()
], SelectedCustomFieldsModelImpl);
export { SelectedCustomFieldsModelImpl };
